import { render, staticRenderFns } from "./hotspots.vue?vue&type=template&id=04a43713&scoped=true&"
import script from "./hotspots.vue?vue&type=script&lang=js&"
export * from "./hotspots.vue?vue&type=script&lang=js&"
import style0 from "./hotspots.vue?vue&type=style&index=0&id=04a43713&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a43713",
  null
  
)

export default component.exports